import { SpaceValues } from "@/lib/utils/SpaceValues";
import { Indent, Row, Space } from "@stenajs-webui/core";
import { Card, CardBody, CardHeader } from "@stenajs-webui/elements";
import { CheckboxWithLabel } from "@stenajs-webui/forms";
import * as React from "react";
import { CountryMultiSelect } from "@/components/data-driven-inputs/selects/country-multi-select/CountryMultiSelect";
import { GoodsMultiSelect } from "@/components/data-driven-inputs/selects/goods-multi-select/GoodsMultiSelect";
import { FieldCaption } from "@/components/forms/FieldCaption";
import { ConditionsFormModel } from "../types/ConditionsFormModel";
import {
  HeadAgreementStatusCode,
  RouteAgreementDetailsStateFragment,
} from "@/gql/graphql";

interface Props {
  value: ConditionsFormModel;
  setFields: (value: Partial<ConditionsFormModel>) => void;
  routeAgreement: RouteAgreementDetailsStateFragment;
}

export const ConditionsForm: React.FC<Props> = React.memo(
  ({
    setFields,
    routeAgreement,
    value: { goods, countryReceiver, countrySender, standby, transit },
  }) => {
    return (
      <Card>
        <CardHeader text={"Conditions"} />
        <CardBody width={"500px"}>
          <FieldCaption label={"Country sender"}>
            <CountryMultiSelect
              value={countrySender}
              onValueChange={(countrySender) => setFields({ countrySender })}
              optionsToRemove={countryReceiver}
              isDisabled={
                routeAgreement.statusCode === HeadAgreementStatusCode.Active
              }
            />
          </FieldCaption>
          <Space />
          <FieldCaption label={"Country receiver"}>
            <CountryMultiSelect
              value={countryReceiver}
              onValueChange={(countryReceiver) =>
                setFields({ countryReceiver })
              }
              isDisabled={
                routeAgreement.statusCode === HeadAgreementStatusCode.Active
              }
              optionsToRemove={countrySender}
            />
          </FieldCaption>
          <Space />
          <FieldCaption label={"Goods"}>
            <GoodsMultiSelect
              value={goods}
              isDisabled={
                routeAgreement.statusCode === HeadAgreementStatusCode.Active
              }
              onValueChange={(goods) => setFields({ goods })}
            />
          </FieldCaption>
          <Space num={SpaceValues.SIXTEEN} />
          <Row>
            <CheckboxWithLabel
              label={"Standby"}
              value={standby}
              disabled={
                routeAgreement.statusCode === HeadAgreementStatusCode.Active
              }
              onValueChange={(standby) => setFields({ standby })}
            />
            <Indent />
            <CheckboxWithLabel
              label={"Transit"}
              value={transit}
              disabled={
                routeAgreement.statusCode === HeadAgreementStatusCode.Active
              }
              onValueChange={(transit) => setFields({ transit })}
            />
          </Row>
        </CardBody>
      </Card>
    );
  }
);
